(() => {
  const E = window.NiwaShipping;
  if (!E || customElements.get('niwa-shipping')) return;
  let destination = '';
  try { destination = localStorage.getItem('niwa-shipping-pref') || ''; } catch (_) {}
  let deliveryOptions = {island:false,alternative:false};
  try { const saved=JSON.parse(localStorage.getItem('niwa-shipping-options')||'{}');deliveryOptions={island:saved.island===true,alternative:saved.alternative===true}; } catch (_) {}
  let cartState = null, pending;
  const all = () => [...document.querySelectorAll('niwa-shipping')];
  async function refreshCart() {
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {credentials:'same-origin'});
      if (!response.ok) throw Error('cart');
      cartState = await response.json();
      all().forEach(node => { if (node.dataset.mode === 'cart') node.render(); });
    } catch (_) {
      all().filter(node => node.dataset.mode === 'cart').forEach(node => {
        node.querySelector('[data-result]').textContent = 'カートを取得できませんでした。ページを更新してお試しください。';
      });
    }
  }
  function scheduleCart() { clearTimeout(pending); pending = setTimeout(refreshCart, 450); }
  class NiwaShipping extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.pref = this.querySelector('[data-pref]');
      Object.keys(E.DATA.regions).forEach(pref => this.pref.add(new Option(pref,pref)));
      this.pref.value = destination;
      this.pref.addEventListener('change', () => {
        destination = this.pref.value;
        try { localStorage.setItem('niwa-shipping-pref',destination); } catch (_) {}
        all().forEach(node => { node.pref.value=destination; node.render(); });
        document.dispatchEvent(new CustomEvent('niwa:delivery-change',{detail:{pref:destination,...deliveryOptions}}));
      });
      const syncOptions=()=>{
        deliveryOptions={island:this.querySelector('[data-island]').checked,alternative:this.querySelector('[data-alternative]').checked};
        try {localStorage.setItem('niwa-shipping-options',JSON.stringify(deliveryOptions));} catch (_) {}
        all().forEach(node=>{node.querySelector('[data-island]').checked=deliveryOptions.island;node.querySelector('[data-alternative]').checked=deliveryOptions.alternative;node.render();});
        document.dispatchEvent(new CustomEvent('niwa:delivery-change',{detail:{pref:destination,...deliveryOptions}}));
      };
      this.querySelector('[data-island]').checked=deliveryOptions.island;
      this.querySelector('[data-alternative]').checked=deliveryOptions.alternative;
      this.querySelector('[data-island]').addEventListener('change',syncOptions);
      this.querySelector('[data-alternative]').addEventListener('change',syncOptions);
      const data = this.querySelector('[data-shipping-product]');
      if (data) { try { this.product = JSON.parse(data.textContent); } catch (_) {} }
      this.querySelector('[data-copy-quote]')?.addEventListener('click', () => this.copyQuote());
      this.onInput = () => this.render();
      if (this.product) {
        this.host = this.closest('product-info');
        this.host?.addEventListener('input',this.onInput);
        this.host?.addEventListener('change',this.onInput);
        this.observer = new MutationObserver(() => this.render());
        const price = this.host?.querySelector('[id^="price-"]');
        if (price) this.observer.observe(price,{childList:true,subtree:true,characterData:true});
      } else refreshCart();
      this.render();
    }
    disconnectedCallback() {
      this.host?.removeEventListener('input',this.onInput);
      this.host?.removeEventListener('change',this.onInput);
      this.observer?.disconnect();
    }
    async copyQuote() {
      const status=this.querySelector('[data-copy-status]');
      const box=this.querySelector('[data-copy-text]');
      const button=this.querySelector('[data-copy-quote]');
      button.disabled=true;status.textContent='商品情報を確認しています…';box.hidden=true;
      try {
        let rows;
        if(this.product){
          const q=Number(this.host?.querySelector('input[name="quantity"]')?.value||1);
          const id=this.host?.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
          const v=this.product.variants.find(v=>String(v.id)===String(id))||this.product.variants[0];
          rows=[{handle:this.product.handle,title:this.product.title,variant:v.title,q}];
        }else{
          const response=await fetch((window.Shopify?.routes?.root||'/')+'cart.js',{credentials:'same-origin',cache:'no-store'});
          if(!response.ok)throw Error('カートを取得できませんでした。ページを更新してお試しください。');
          const cart=await response.json();
          rows=cart.items.map(x=>({handle:x.handle,title:x.product_title,variant:x.variant_title,q:x.quantity}));
        }
        if(!rows.length)throw Error('カートに商品がありません。');
        if(rows.some(x=>!Number.isSafeInteger(x.q)||x.q<1))throw Error('商品の数量を確認してください。');
        const lines=['送料・配送方法の見積もりをお願いします。','','【ご希望の商品】'];
        rows.forEach((x,i)=>{lines.push((i+1)+'. '+x.title);if(x.variant&&x.variant!=='Default Title')lines.push('規格：'+x.variant);lines.push('数量：'+x.q,'商品URL：https://shop.niwaishi.co.jp/products/'+encodeURIComponent(x.handle));});
        lines.push('','【お届け先・配送条件】','都道府県：'+(this.pref.value||'未選択'),'離島への配送：'+(this.querySelector('[data-island]').checked?'あり':'チェックなし（該当する場合は追記してください）'),'支店止め・路線便・チャーター便の見積もり希望：'+(this.querySelector('[data-alternative]').checked?'あり':'チェックなし'),'詳細住所：問い合わせフォームの住所欄に追記してください。','','【追加のご相談】','希望する配送方法・受取支店・フォークリフトの有無などをご記入ください。');
        box.value=lines.join('\n');
        try{
          await navigator.clipboard.writeText(box.value);
          status.textContent='コピーしました。「② 問い合わせフォームを開く」から、ご相談内容に貼り付けてください。';
        }catch(_){
          box.hidden=false;box.focus();box.select();
          status.textContent='自動コピーが使えません。下の文章をコピーして、ご相談内容に貼り付けてください。';
        }
      }catch(error){status.textContent=error.message||'コピーできませんでした。ページを更新してお試しください。';}
      finally{button.disabled=false;}
    }
    render() {
      if (!this.pref) return;
      this.querySelector('[data-alternative-note]').hidden=!this.querySelector('[data-alternative]').checked;
      const out = this.querySelector('[data-result]');
      if (!this.pref.value) { out.textContent='都道府県を選択してください。'; return; }
      let items, subtotal;
      if (this.product) {
        const qty = Number(this.host?.querySelector('input[name="quantity"]')?.value || 1);
        const id = this.host?.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
        const variant = this.product.variants.find(v => String(v.id) === String(id)) || this.product.variants[0];
        items=[{handle:this.product.handle,title:this.product.title,q:qty,unitGrams:variant.weight}];
        subtotal=variant.price*qty/100;
      } else {
        if (!cartState) { out.textContent='カートを確認しています…'; return; }
        items=cartState.items.map(item => ({handle:item.handle,title:item.product_title,q:item.quantity,unitGrams:item.grams}));
        subtotal=cartState.total_price/100;
        if (!items.length) { out.textContent='カートに商品がありません。'; return; }
      }
      const result=E.estimate(items,this.pref.value,this.querySelector('[data-island]').checked);
      const line=(text,value,cls='')=>`<div class="niwa-shipping__line ${cls}"><span>${text}</span><strong>${value}</strong></div>`;
      const details=items.length>1?'<details class="niwa-shipping__breakdown"><summary>商品別送料の内訳を見る</summary><ul>'+items.map(item=>{
        const r=E.estimate([item],this.pref.value,this.querySelector('[data-island]').checked);
        return `<li>${E.esc(item.title)} × ${item.q}：${r.amount===null?'個別見積もり':E.yen(r.amount)}</li>`;
      }).join('')+'</ul></details>':'';
      out.innerHTML=line('商品金額',E.yen(subtotal))+line('宅配便の目安送料',result.amount===null?'個別見積もり':E.yen(result.amount))+line('商品代＋宅配便送料の目安',result.amount===null?'送料確認後':E.yen(subtotal+result.amount),'niwa-shipping__total')+details+'<small>'+E.esc(result.reason||'')+'</small>';
    }
  }
  customElements.define('niwa-shipping',NiwaShipping);
  document.addEventListener('submit',event=>{
    if (event.target.matches('form[action*="/cart/add"]')) {
      setTimeout(refreshCart,800); setTimeout(refreshCart,1800);
    }
  });
  function mountCartDisplays() {
    document.querySelectorAll('cart-drawer .drawer__footer,cart-notification #cart-notification-product').forEach(host=>{
      if (host.querySelector('niwa-shipping')) return;
      const template=document.querySelector('#niwa-cart-estimate-template');
      if (!template) return;
      const node=template.content.firstElementChild.cloneNode(true);
      host.append(node);
    });
  }
  mountCartDisplays();
  document.querySelectorAll('cart-items,cart-drawer,cart-notification').forEach(host=>{
    new MutationObserver(records=>{
      if (records.every(r=>r.target.closest?.('niwa-shipping'))) return;
      mountCartDisplays(); scheduleCart();
    }).observe(host,{childList:true,subtree:true});
  });
  window.addEventListener('pageshow',scheduleCart);
  window.addEventListener('storage',event=>{
    if (event.key==='niwa-shipping-pref') {destination=event.newValue||'';all().forEach(node=>{node.pref.value=destination;node.render();});}
  });
})();

// Enforce the confirmed limit in product and cart controls, without changing inventory.
(() => {
 const E=window.NiwaShipping;if(!E)return;
 const limited=Object.entries(E.DATA.rules).filter(([,r])=>r.purchaseMax);
 if(!limited.length)return;
 const limitFor=h=>E.DATA.rules[h]?.purchaseMax;
 function sync(){
  document.querySelectorAll('niwa-shipping[data-mode="product"]').forEach(node=>{
   const limit=limitFor(node.dataset.handle);if(!limit)return;
   const host=node.closest('product-info');if(!host)return;
   const input=host.querySelector('input[name="quantity"]');if(!input)return;
   const inCart=Number(input.dataset.cartQuantity)||0,remaining=Math.max(0,limit-inCart);
   input.max=String(remaining);input.dataset.max=String(remaining);
   const invalid=!Number.isSafeInteger(Number(input.value))||Number(input.value)<1||Number(input.value)>remaining;
   input.setCustomValidity(invalid?'この商品のご注文数量は、カート内と合わせて'+limit+'までです。':'');
   host.querySelectorAll('[name="add"],.shopify-payment-button button').forEach(button=>{
    if(invalid){if(!button.disabled)button.dataset.niwaLimitDisabled='true';button.disabled=true;}
    else if(button.dataset.niwaLimitDisabled){button.disabled=false;delete button.dataset.niwaLimitDisabled;}
   });
  });
  document.querySelectorAll('niwa-shipping[data-mode="cart"]').forEach(node=>{
   const root=node.closest('cart-drawer')||document;
   for(const [handle,rule] of limited){
    root.querySelectorAll('a[href*="/products/"]').forEach(a=>{
     let h;try{h=decodeURIComponent(new URL(a.href).pathname.split('/products/')[1]?.split('/')[0]||'')}catch(_){return}
     if(h!==handle)return;
     const row=a.closest('.cart-item');const input=row?.querySelector('input[name="updates[]"]');if(!input)return;
     input.max=String(rule.purchaseMax);input.dataset.max=String(rule.purchaseMax);
    });
   }
  });
 }
 document.addEventListener('input',sync);document.addEventListener('change',sync);
 document.addEventListener('submit',event=>{
  if(!event.target.matches('form[action*="/cart/add"]'))return;
  sync();const host=event.target.closest('product-info');const input=host?.querySelector('input[name="quantity"]');
  if(input&&!input.checkValidity()){event.preventDefault();event.stopImmediatePropagation();input.reportValidity();}
 },true);
 sync();document.addEventListener('shopify:section:load',sync);
})();
